export default {
  INVALID_MSISDN: 'Destination Address Error',
  OPERATOR_REJECTED: 'Invalid state or parameters',
  SMSC_ERROR: 'Operator System Error',
  INSUFFICIENT_FUNDS: 'Temporary Error',
  UNKNOWN_MSISDN: 'Unknown Subscriber',
  TEMPORARY_OPERATOR_ERROR: 'Temporary network/roaming issue',
  UNREACHABLE_MSISDN: 'Mobile not reachable or temporary busy',
  INVALID_OPERATOR_SERVICE: 'Service not supported from mobile or operator',
  PERMANENT_OPERATOR_ERROR: 'Permanent Error (network/parameters)',
  TEMPORARY_BARRED: 'Temporary Barred',
  PERMANENTLY_BARRED: 'Permanently Barred',
  UNKNOWN_ERROR: 'Unknown Error',
  MAX_SPEND_MSISDN: 'Spend Limit Reached',
  OPERATOR_TIMEOUT: 'Operator has not acknowledged. Message might have been sent',
  UNROUTABLE: 'Unable to route the message',
  INVALID_REQUEST: 'Invalid service, subscription, transaction or price point',
  OPERATOR_ERROR: 'Operator System Error',
  D2B_BARRED: 'Direct billing not allowed',
  DUPLICATE: 'Transaction already processed',
  TEMPORARY_FAILURE: 'Temporary failure',
  SECTOR_NOT_ALLOWED: 'Service not allowed to bill in the specified sector',
  OPERATOR_SRV_DAILY_MAX_SPEND: 'Daily Spend Limit Reached',
  OPERATOR_SRV_WEEKLY_MAX_SPEND: 'Weekly Spend Limit Reached',
  OPERATOR_SRV_MONTHLY_MAX_SPEND: 'Monthly Spend Limit Reached',
  OPERATOR_SRV_TYPE_DAILY_MAX_SPEND: 'Daily Spend Limit Reached',
  OPERATOR_SRV_TYPE_WEEKLY_MAX_SPEND: 'Weekly Spend Limit Reached',
  OPERATOR_SRV_TYPE_MONTHLY_MAX_SPEND: 'Monthly Spend Limit Reached',
  NOT_CONFIRMED_AFTER_24_HOURS: 'Not confirmed after 24 hours',
  'N/A': 'Not applicable'
}
